import React from 'react'
import { Container, Content, ListItem, ModalContent, ModalList, ModalTitle, Section, ServicesBtn, ServicesModal, ServicesTitle, Subtitle, Title } from './ServicesStyles'
import { UilWebGrid , UilArrowRight,UilDatabase  ,UilCloudDatabaseTree , UilTimes ,UilCheckCircle } from '@iconscout/react-unicons'
import { useState } from 'react'
import { useRef } from 'react';

function Services() {

    const [openFrontend, setOpenfront] = useState(false);
    const [openBackend, setOpenback] = useState(false);
    const [openDb, setOpendb] = useState(false);

    const toggleOpenback = () =>{
        setOpenback(!openBackend);
    }

    const toggleOpenFront = () =>{
        setOpenfront(!openFrontend);
    }

    const toggleOpendb = () =>{
        setOpendb(!openDb)
    }

    return (
        <Section className="services-section">
            <Title>Services</Title>
            <Subtitle>What i offer</Subtitle>

            <Container>
                {/* frontend dev */}
                <Content>
                    <div>
                        <UilWebGrid size="1.5rem" className="service-icon"/>
                        <ServicesTitle>Frontend <br/> Developer</ServicesTitle>
                    </div>

                    <ServicesBtn onClick={toggleOpenFront}  className="btn-link btn-small">
                        View More 
                        <UilArrowRight size="1.25rem" className="btn__icon"/>
                    </ServicesBtn>
                    <ServicesModal open={openFrontend}>
                        <ModalContent>
                            <ModalTitle>Frontend <br/> Developer</ModalTitle>
                            <UilTimes onClick={toggleOpenFront} className="modal-close"/>

                            <ModalList>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I develop the user interface.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>Web page development.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I create ux element interactions.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I position your company brand.</p>
                                </ListItem>
                            </ModalList>
                        </ModalContent>
                    </ServicesModal>
                </Content>
                {/* Backend dev */}
                <Content>
                    <div>
                        < UilCloudDatabaseTree  size="1.5rem" className="service-icon"/>
                        <ServicesTitle>Backend <br/> Developer</ServicesTitle>
                    </div>

                    <ServicesBtn onClick={toggleOpenback} className="btn-link btn-small">
                        View More 
                        <UilArrowRight size="1.25rem" className="btn__icon"/>
                    </ServicesBtn>
                    <ServicesModal open={openBackend}>
                        <ModalContent>
                            <ModalTitle>Backend <br/> Developer</ModalTitle>
                            <UilTimes onClick={toggleOpenback}  className="modal-close"/>

                            <ModalList>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I develop the endpoint.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I build APIs.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I create business logic for the fontend.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I integrate and build on external APIs.</p>
                                </ListItem>
                            </ModalList>
                        </ModalContent>
                    </ServicesModal>
                </Content>
               {/* database developer */}
                <Content>
                    <div>
                        <UilDatabase size="1.5rem" className="service-icon"/>
                        <ServicesTitle>Database <br/> Developer</ServicesTitle>
                    </div>

                    <ServicesBtn onClick={toggleOpendb} className="btn-link btn-small">
                        View More 
                        <UilArrowRight size="1.25rem" className="btn__icon"/>
                    </ServicesBtn>
                    <ServicesModal open={openDb} >
                        <ModalContent>
                            <ModalTitle>Database <br/> Developer</ModalTitle>
                            <UilTimes onClick={toggleOpendb}  className="modal-close"/>

                            <ModalList>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I build models for database.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>connect the endpoints to the database.</p>
                                </ListItem>
                                <ListItem>
                                    <UilCheckCircle className="modal-icon"/>
                                    <p>I structure the database.</p>
                                </ListItem>
                            </ModalList>
                        </ModalContent>
                    </ServicesModal>
                </Content>

            </Container>
        </Section>
    )
}

export default Services
